import { keyframes } from 'styled-components';

const push = keyframes`
  50% { transform: scale(0.6); }
`;

const dots = keyframes`
  25% { content: ''; }
  50% { content: '.'; }
  75% { content: '..'; }
  100% { content: '...'; }
`;

export default { push, dots };
